import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import posts from '../Posts';

import './Blog.css';

function formatDate(dateStr) {
    const date = new Date(dateStr);

    return date.toLocaleDateString('ro-RO', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
}

const Blog = () => {
    const [activeTag, setActiveTag] = useState('Toate');

    const allTags = useMemo(() => {
        const tagSet = new Set();
        posts.forEach((post) => post.tags?.forEach((tag) => tagSet.add(tag)));
        return ['Toate', ...Array.from(tagSet)];
    }, []);

    const filteredPosts = useMemo(() => {
        if (activeTag === 'Toate') return posts;
        return posts.filter((post) => post.tags?.includes(activeTag));
    }, [activeTag]);

    return (
        <section className="blog-section worldwide">
            <div className="container">
                <div className="blog-header">
                    <p className="blogTitle">
                        <span className="bracket">{'<'}</span>
                            Blog
                        <span className="bracket">{'/>'}</span>
                    </p>
                    <p className="blogSubTitle">Află lucruri interesante citindu-mi blog-urile</p>
                </div>

                {allTags.length > 1 && (
                <div className="blog-filters">
                    {allTags.map((tag) => (
                    <button
                        key={tag}
                        type="button"
                        className={`blog-filter-btn${
                            activeTag === tag ? ' active' : ''
                        }`}
                        onClick={() => setActiveTag(tag)}
                    >
                        {tag === 'Toate' ? tag : `#${tag}`}
                    </button>
                    ))}
                </div>
                )}

                <div className="blog-grid">
                    {filteredPosts.map((post) => (
                        <article className="blog-card" key={post.id}>
                            {post.cover && (
                                <div className="blog-card-cover">
                                    <img src={post.cover} alt={post.title} loading="lazy" />
                                </div>
                            )}

                            <div className="blog-card-body">
                                <div className="blog-card-meta">
                                    <span className="blog-card-number">#{post.number}</span>
                                    <span className="blog-card-date">
                                        {formatDate(post.date)}
                                    </span>
                                    <span className="blog-card-dot" aria-hidden="true">
                                        •
                                    </span>
                                    <span className="blog-card-read">{post.readTime}</span>
                                </div>

                                <h3 className="blog-card-title">{post.title}</h3>
                                <p className="blog-card-excerpt">{post.excerpt}</p>

                                {post.tags?.length > 0 && (
                                <div className="blog-card-tags">
                                    {post.tags.map((tag) => (
                                    <span className="blog-card-tag" key={tag}>
                                        #{tag}
                                    </span>
                                    ))}
                                </div>
                                )}

                                <Link to={`/blog/${post.id}`} className="blog-card-btn">
                                    Citește mai mult
                                </Link>
                            </div>
                        </article>
                    ))}

                    {filteredPosts.length === 0 && (
                        <p className="blog-empty">
                            Nu există încă articole pentru acest tag.
                        </p>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Blog;